import React, { useEffect, useState } from 'react'
import NavBar from './NavBar'
import AgwePage from './pages/AgwePage'
import Map from './pages/Map'
import ResourcesPage from './pages/ResourcesPage'
import AboutUsPage from './pages/AboutUs'
import { Grid, Slider, Select, MenuItem, Typography } from '@mui/material'
import ContactUs from './pages/ContactUs'
import CLegend from './images/ChloroLegend.png'
import sALegend from './images/SALegend.png'

import cloneDeep from 'lodash/cloneDeep'

function MainWhole () {
  const [viewPage, setViewPage] = useState('MapPage')
  // const [viewPage, setViewPage] = useState('ContactUsPage')
  const [count, setCount] = useState(0)
  const [mode, setMode] = useState('Yearly')
  const modeChoices = ['Yearly', 'Monthly']
  const factorList = ['chlorophyl', 'sst']
  const [factor, setFactor] = useState('chlorophyl')

  const sourcesYear = [
    {
      year: 'Clear View',
      data: { chlorophyl: ['', '', ''], sst: ['', '', ''] }
    },
    {
      year: 2016,
      data: {
        chlorophyl: [
          'https://cdn.filesend.jp/private/9-Kqn6tySOHnjUey4yPtkwBjfWAQA1Iw42gAWzW-p4SN5Osc75nhfX_Psu2-Tohb/2016_Chesapeake%20Bay%20%281%29.kmz',
          'https://cdn.filesend.jp/private/VfvWnvSWHNLDRO8kSD0bycyPLuyW0Et7-yBORPnjfH7CIvkLn6PSlc3eeDQaJ2A1/2016_Florida.kmz',
          'https://cdn.filesend.jp/private/2-jBTiI8pY8K1rYPVAGATDa3oLVk505qHrQsm6K5zyQbujGa-YWS4ZM7CdbJCbV_/2016_PH.kmz'
        ],
        sst: [
          'https://cdn.filesend.jp/private/AGMoRfVXddEUtrNCCtpcS3jlF3WCiDW0AfDrnFOaZVd1ptGDrFwHOgZRmJodhDv0/2016_Chesapeake%20Bay%20%282%29.kmz',
          'https://cdn.filesend.jp/private/hVig_WIdDHHpaPgQh48IWjtU6T3DTNKIkd6ETR57MXU8xWjw-jIx1Wkb23Jx46gT/2016_Florida%20%281%29.kmz',
          'https://cdn.filesend.jp/private/U2HEEgx16Pp46MkGBKt2l6PEkHvZWoj1lNMnu9OzwKZ9E1SOmKJyC_dxvvCeEx8Z/2016_Manila%20Bay.kmz'
        ]
      }
    },
    {
      year: 2017,
      data: {
        chlorophyl: [
          'https://cdn.filesend.jp/private/5jPnaMg8vNBlQEZVbxxbZyArHZKCMVa2SkseXYPR1uTlxZBuA2Ga9y7-IrlEOSGd/2017_Chesapeake%20Bay.kmz',
          'https://cdn.filesend.jp/private/GiEUlkN8Sy1qozIjuAXKebbIgUyvpxHbmFlVxQSe4tbyZiqmVw6E_nla5nh6geMx/2017_Florida.kmz',
          'https://cdn.filesend.jp/private/j0RVWB1UXhqZ6PFy6f6s37CbYdFHpz8mLfppbfrx2m5HNzi3toAKAYo80CX7zY7S/2017_PH.kmz'
        ],
        sst: [
          'https://cdn.filesend.jp/private/doNN0vSr_b6e3OlMB2PS0zYy_auyjySpf3FLDufftzOpLg7EgjS8PCp7kE6NEH04/2017_Chesapeake%20Bay%20%282%29.kmz',
          'https://cdn.filesend.jp/private/DcKwlk_5AJ-qMYlICkRZBW-uQVF_ffhR6jE_Zk09C2cGaFoL-WczSOK81OnBZpxQ/2017_Florida%20%281%29.kmz',
          'https://cdn.filesend.jp/private/5irKFRfEKcKHg6FKi0MSs-4xwnuQdMYGyVC-RamQ-_SpQiU-va6R74YmhHg7D_S2/2017_Manila%20Bay.kmz'
        ]
      }
    },
    {
      year: 2018,
      data: {
        chlorophyl: [
          'https://cdn.filesend.jp/private/FsEbNFBL760P3cxfV0NCeoJW9Ur_WO0kntYQmUmcZ6e1cVavLm5a-bftZMfA8DJW/2018_Chesapeake%20Bay.kmz',
          'https://cdn.filesend.jp/private/SvJBYPwT8i61M-Hgvn-8oQElzkVW2_bf8J4aO7Sg6vU4aNrTjmgMuwh1HPwkgBT1/2018_Florida.kmz',
          'https://cdn.filesend.jp/private/IIvpZKrH2Q3blia_H_pyGUt416-EViip-DQCRdm3VI321MQ3oqbXRedcxv-fuQlz/2018_PH.kmz'
        ],
        sst: [
          'https://cdn.filesend.jp/private/vvoey2wAVdXjDQl3E6Mc9IsvuPIQuUipkzvtk_GF6KPvUtxtuEG1jRhqqvhZoLFv/2018_Chesapeake%20Bay%20%281%29.kmz',
          'https://cdn.filesend.jp/private/q8BrRW8vqiZFGBMOhMfkzZSsLbyufBH4yH6ZUQiOT9_4B4MV8reo-0hf1a63BP6N/2018_Florida%20%281%29.kmz',
          'https://cdn.filesend.jp/private/u5nczKlaF50bihnypED9sVhKtqxUr-Q0bIAvJX942u-oihRbX-rmVnjG2caORzts/2018_Manila%20Bay.kmz'
        ]
      }
    },
    {
      year: 2019,
      data: {
        chlorophyl: [
          'https://cdn.filesend.jp/private/QKzvmTiiT6h4aeRatoQaLxN0r-6lO4C-2J46eP2lNgJWiqUhM-CQy3XgRNqaDmdr/2019_Chesapeake%20Bay.kmz',
          'https://cdn.filesend.jp/private/7dFrYMbO_TGvK9tCJJ9xVLrSTgLOnPKQxcK7Yyak6RgMGjDP_t0CtgbPxyxZQGQH/2019_Florida.kmz',
          'https://cdn.filesend.jp/private/Fow1lQ-ZQVjmQp2ZczfsZuSrkFLYFgSo9oIJpjh1rS2xyuVxhv5S5X0XTp7dGoM-/2019_PH.kmz'
        ],
        sst: [
          'https://cdn.filesend.jp/private/yeTs0kVtjMgqGQ4-1PYBCyf4n7YqWkNc_6yF-w03G1kP3Ns1xd7jeAJmoYmhv53p/2019_Chesapeake%20Bay%20%281%29.kmz',
          'https://cdn.filesend.jp/private/BiAW8J8wg8RFIaHcQF5uos0Y1bTfd_lffYzUG6J3bHf-t47cEGIo56YFcllF89Or/2019_Florida%20%281%29.kmz',
          'https://cdn.filesend.jp/private/Xw50wzNjJ5zPRzhinHb4geWpL_-DtWiiOyVlGhFbQ37z9HeJMUHZvvEKzAqg9Xjc/2019_Manila%20Bay.kmz'
        ]
      }
    },
    {
      year: 2020,
      data: {
        chlorophyl: [
          'https://cdn.filesend.jp/private/bSTZsx1FMRolzzMrjDUHpq7Cx80QGRg7ghzL_dqcdsWKv9QNdV4t-y3a6-GJ_wFN/2020_Chesapeake%20Bay.kmz',
          'https://cdn.filesend.jp/private/xqm79-03lnCfiCgSxsua9pguKB_rOWaCX--0iv6-RIA82KIOk6kMp6aZrS4R1GJq/2020_Florida.kmz',
          'https://cdn.filesend.jp/private/lqZB4WGEIzFWmvldmINC1nzsJ2kpcb5zCXZaW8-liLscoVyIJkr5xp2Juw2HT7mW/2020_PH.kmz'
        ],
        sst: [
          'https://cdn.filesend.jp/private/x7OvCNKm6zcXZFeAUC-zsTvlJx8nUvTSsg0CW0p2qyaO0tBlsfpjKXOZe-oEmIBz/2020_Chesapeake%20Bay%20%281%29.kmz',
          'https://cdn.filesend.jp/private/BmdrWDMuPenzHpISLpKLBqq_g86-X4R3ivQMHbSPluDGsruPe3foJyvyEEPNIdJV/2020_Florida%20%281%29.kmz',
          'https://cdn.filesend.jp/private/LvwalD82WgvusAeAkSQTORk5EuaxBhPsUBUnK_QDIsaUMYvI4xf-WUS8iRloDBnM/2020_Manila%20Bay.kmz'
        ]
      }
    }
  ]
  const sourceMonth = [
    {
      year: '2016',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/G1vgVidreh0prTWXQDQlMfeyrKyDrfyoX6F3RgXDKr4DI2VzJAwx1QFJ_ohgvPdw/2016_Jan.kmz',
            'https://cdn.filesend.jp/private/jWPvIFTJLQa6AFHcENfhwwC2VvbUCl7uTgt12LHp41ri8dA6U2RlobqZflS4segq/2016_Jan.kmz',
            'https://cdn.filesend.jp/private/zMwSZ63SVdyJFi9m0jAjwAWcQ_TmLrEAIQhc5YSLgw5yyAPfYyrCekjb3Hj1BFDk/2016_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Xh8bhoBhtiINV_5gkm-fpNYffqOx0qM-x5UGY-oKlssOomLn_mEe-WygXjaidqro/2016_Feb.kmz',
            'https://cdn.filesend.jp/private/T4vce-s2j0fVwed1n4t5LoiO9G6jeXB4IKmPiWpDkQ0IwPeUnTNqchmCjds8HTWW/2016_Feb.kmz',
            'https://cdn.filesend.jp/private/Z7I9UXhRQs413HXOdsmaWtTqQZ5L0tEilwg8mcdpDY_SE26XKr-MAtVOT0aqkDW1/2016_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/0PVTtu6qPPbsq0QmIq2teDVs2OPNymTF4GZO2z09VH8uYKAe1v_G2pMYOdQecDlx/2016_March.kmz',
            'https://cdn.filesend.jp/private/Jq61fvjnzNWGzas6Kq1HEzAmHKADurHM6c4fi_IrR-zff52qw_Nlh8HGXfNswvd5/2016_Mar.kmz',
            'https://cdn.filesend.jp/private/PzC1eal_DJ-yJ0bRDa92MoL_ouWztmtIbbRNtpSUP1DCah0R9q6vrJkVVe5KS1YN/2016_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/cuFT31gNVXPsLBZclPWfhmiZqZr0dfrZMCMNvC8xTj-uFtImWfVK75_1A1E-A73q/2016_April.kmz',
            'https://cdn.filesend.jp/private/SHQFT34Bdm-5qLbPhvwEGmU9GjFtZ0LIlUIWUVibKNMKoOI8s-j4xeUeyCI1RGyV/2016_Apr.kmz',
            'https://cdn.filesend.jp/private/2rsDx_-dnoknVioh-dupiTT87EOHh_eF5Sfiv-nRfX1jOXtF2LIv-Aklf16Kf6P0/2016_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/u06uSG37aBrRenyNlhAKUljsLFZmt1z4NW43kIRN46zMHfEfwTULsiL7970Kwjcm/2016_May.kmz',
            'https://cdn.filesend.jp/private/TKPQ9Rsvw8hjSvlzu0vF0C5rk51WLeByLwFdOqcw43yfFX8-ingHiUuQMiNBksw2/2016_May.kmz',
            'https://cdn.filesend.jp/private/ZqiRvN7u1nUOju-E_ujc5Ufwm76tq3HkoWGvZeYjVO15vOKP8bd070-FfR6SXHp9/2016_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/I4dsexrdv3mjs_ycxNtWxfLQIanqeJnV8d_bEO8EDn1_gBAOE12LoLKqLYdO40CS/2016_June.kmz',
            'https://cdn.filesend.jp/private/EgxLMBlfm8RxBV_LIXkbY866GtXacHoHJJ_4lVyrMFgs6jjmfGhqikWwgaIRmNw_/2016_Jun.kmz',
            'https://cdn.filesend.jp/private/cCN0Qr6y3qizpusdxjBZx06w67DjQeUS7Ka0QpFHwmV8IlxJqK5ZQ6y0vc_I4uO5/2016_June.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/ybXTFvCfTiFOLM_I5Ym_xnygKUb7kWnEih4bzz-PZw3eQ-wkZXBEHUto5FabzNLs/2016_July.kmz',
            'https://cdn.filesend.jp/private/6A6avhFtgR_-xQYwBkVt-0mdu3ksrWV8IIBNk79vZdSFiWNnaYigVy7gDO-_FWv6/2016_Jul.kmz',
            'https://cdn.filesend.jp/private/Bwb3_ppCQIM23Uw0pobG_mMummn04tIVralHPNXvFq1Qave5smByeeLZw5BHsAOq/2016_July.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/pyHbFy-b0ov3k0fLO6SGRI7HYW1SPJNffLA8NKGmbVN21z2tfZlB7b_LUv_laOOY/2016_Aug.kmz',
            'https://cdn.filesend.jp/private/q_yXFt_Fxt4DmpzHpLnErJdIWJrDoNIeaLFIPrgiHylyoDIrEeTq1NpxOVxU2BUr/2016_Aug.kmz',
            'https://cdn.filesend.jp/private/P51F89KA-Twc3XP3U6mmMUliSOZeOpmkV-cL6LxsE9lfEl88l8H4Vh_KHmOTEtg3/2016_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/pLR2qqidLrz08HMfVThzsKiUqrcJ8eP-wGL1OIow0DCegBit_YDRfSIF-SZ98CN1/2016_Sept.kmz',
            'https://cdn.filesend.jp/private/XhX0ualZGl4UcQEzjx8dA4CReJGYsTbxG3uVTfXdBjaikjnO-Muj6rWjnBh1ZCi-/2016_Sep.kmz',
            'https://cdn.filesend.jp/private/vpV8jPn-UQ2y7P2El7YDZvmrJkDMp_G2C7k-6k8RAWpHstCELeKu_pWX4i9XWWc8/2016_Sept.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/2TrlfHtSQU4Fqfos7Xwv5mXcNJw41Gf_Nsw6QLyPQHcLe4bg0z60dKNvuxyuropU/2016_Oct.kmz',
            'https://cdn.filesend.jp/private/hvbVCDkvXaNNqQitAf0SHkf2p3oV4o7I-HPIPk3-nRC5YijRC18I8VRk_itA38WG/2016_Oct.kmz',
            'https://cdn.filesend.jp/private/qC6eB886enggpPkxbCd8ssfiqoMK-I214hcI_AGayvMvcaVxvws-r44_BGasV9lu/2016_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/N_aJ8zLz1x4pbDFshkeDg9Yg_XnWoWFz038f1v7qB9IJpSMaSn1HjraTWJfxF0QP/2016_Nov.kmz',
            'https://cdn.filesend.jp/private/YjggJuws0qQnPH2XbUKsNAyM6E6gOhWvk8HhsC4cycg9JaYlqK1o5J3maa2jd84v/2016_Nov.kmz',
            'https://cdn.filesend.jp/private/nBwFkl0v6r05hosx65Ewn4z3IIT5UaRfpA9PUWS1e9q2anqBNGSk-n4xtsks8J2T/2016_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/EeRy7sjQUk9nRMX61QrlxqXEJ5_yvQ1X7npZpXU3dXq88GSoB9fh1R3qwuQuD4pF/2016_Dec.kmz',
            'https://cdn.filesend.jp/private/iqkiYqrzFce0vJnlVWrHKN64BuhT08mU_pCS9bZJABpAOC26J0qowc6Rt2oZb-ME/2016_Dec.kmz',
            'https://cdn.filesend.jp/private/vWbOMtBL3jZTgvEgveh-RDKOZ4fPEco5T81UwC9MUHt-jTpq30OEu_lH9i2hnbW6/2016_Dec.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            // Florida, Chesapeake
            'https://cdn.filesend.jp/private/acyi6b34gjvGtZHCzwDPv267cvYkmR3YDh2NFUsnq5zd0CSfG2nVMm18jQTeNdml/2016_Jan.kmz',
            'https://cdn.filesend.jp/private/J0lrC89sj8KiFHzy2hn04AHcuLSh3vpkJbMZE48EJemZSJdCruEd2o_MPsm5_SsI/2016_Jan%20%281%29.kmz',
            'https://cdn.filesend.jp/private/hckgdFzazDUmEWGD7q7r6zFC6O_IGt6uz0BfB5g0vslFxtRjX7KdBF6CGnqEAvDn/2016_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/gdnuV9MIFr2FA1aSRwTZTcPi8n0odsttf-d0HnAG44jGlXpPe6YCK8aUF-6fzq41/2016_Feb.kmz',
            'https://cdn.filesend.jp/private/SKJIDYUXJ6c1olXF7QF0lFx5Mzz0tgMhpn_h1bPSgNdCWhGWQCKpnbN0tgV16fCi/2016_Feb%20%281%29.kmz',
            'https://cdn.filesend.jp/private/a7h_dMt5504PxpmCNs_pIqgQ4csZ60RUksfIHbilYdT13ogQE5NrsP_Wev9tjU7I/2016_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/XIAwXuuKEyGPtH-SUpwop9BlaOcOr9yLUhBHI4QxaNif0ucRBp1Szu7kaiBSVNiF/2016_March.kmz',
            'https://cdn.filesend.jp/private/NiQZAaowDOr-erdd3bTd5hc9mo4YQvdxmRKR31QDYHHj1MtcgvIGDJJhzwfanzMq/2016_Mar.kmz',
            'https://cdn.filesend.jp/private/EGwqitcZv_aS68lync43dvXZL-7VL_Nhjx6Xw0W0ALOmxidBJSvLorfbh2ohiqN_/2016_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/GnTfa66FD9fKv9P19c3dypNodcawwReaM0lcuDByHRGWjKDtviRikBDOj3QrNQ7Q/2016_April.kmz',
            'https://cdn.filesend.jp/private/_bQw8m2RLkBHHgEuRWctQWuTHx_d3fB9vdhyel35J01W0Z8r_LyJjDHiziVqPRGu/2016_Apr%20%281%29.kmz',
            'https://cdn.filesend.jp/private/SXWnei7MoA4dBvRwREgGoc9zkEnAECqSTWfTYFeDh41Zopp4BDq1BIKqq5zoE6Xe/2016_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/qdtL3YzQUKSr_rj9UTBAQMrIsdF_tRlX_j-vYpStGl3z5DvU1LPty6knQ0mVup2H/2016_May.kmz',
            'https://cdn.filesend.jp/private/yyP-cNSNcJbJfgRkaZP7ADgOPwJJ6jAM_sl19QQ2ynx_uxuL_5a5TMGjBtNGruD2/2016_May%20%281%29.kmz',
            'https://cdn.filesend.jp/private/mz4btiX-vTg6WRHoQ7Fpu_GL32vBuAzb1wFGgRKXFuF4qZ828QTMHGWh2kVgE5Or/2016_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Hg5Hpu4paKCPWZbJCTkU5kYmrTtO8e6kztkPQnBqAOH6pTuCaqEbHHqGekw_lXQs/2016_June.kmz',
            'https://cdn.filesend.jp/private/aqRMD3_tnDuLwNKCNBtPC4wceiZrpLJmVzrPEA6nlD6bH2oLhQj2C6SAXaZz9oTq/2016_Jun.kmz',
            'https://cdn.filesend.jp/private/NibRG40OkSSyG7Q8ahGliaxTYQnPDAXlKU7wcj3VY7M3DRR6y8dE6EP8PsxPGM-H/2016_Jun.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/gHRTiLL1nBz0JFMiXQQmznwjBu9n0Ee_lBekoN7rR0-Hb4G0uH8zx1Z9w81zn-ru/2016_July.kmz',
            'https://cdn.filesend.jp/private/mpAi4s9YZhEBKuafWdXU9a5hdDaJ5AewW753pCyTv7pbwrlzBmgcL6WsRQLgF3ve/2016_Jul.kmz',
            'https://cdn.filesend.jp/private/05440911UYVtzdAlsDX_UlBbP0rcEnYW2IEEGXFTZ1UvxvqDqie2AcrAhkBM9KrT/2016_Jul.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/ns7VNq7ftLRkIbHD7Wnd281bUv7A4Z2wgI948HLDMk6-9O4oSRdFuPNewsX4cg5a/2016_Aug.kmz',
            'https://cdn.filesend.jp/private/w_XEEdrp9s01woOUh3w1cSlFhpWBqHllgix0JP4pQ8SiMMZjudp41Ywae4F9d9Z0/2016_Aug%20%281%29.kmz',
            'https://cdn.filesend.jp/private/zA8StPf4LL16S6q0wsuBh6q3mxAIWp7fEAGiKai5kLI0FjfLlX39eZUhaln1zQ0O/2016_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/veaHVIdNZIErcD8zcGfbCTo0Wn2Z_m8dzVp3n2nRHZOls5W_yu1J26R8aaqZGWoC/2016_Sept.kmz',
            'https://cdn.filesend.jp/private/Wpa-PsCf4CNr2YuZJQYuwj4VXXMtadQkuvwntEj5wMPis9_qP8fKu_ikjX69QUJl/2016_Sep.kmz',
            'https://cdn.filesend.jp/private/6IT8VZGb8pkB8A15-2JjeG7VCazqjRghrRcoOnBhyiHEQLfuKEoEYVhR0vk9L9O4/2016_Sep.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/lAzZctw-7LGhrqCvoirz3l9RpzXzUqAWhcHEYq9_QV2JVkWUwxiDLPMMLwfjDB1T/2016_Oct.kmz',
            'https://cdn.filesend.jp/private/EIhVUEQx16vgafOZN4Q3hk0i4UDx9ioaywqrqb3XNajuPluzBXGKR-J6-oP3AQXx/2016_Oct%20%281%29.kmz',
            'https://cdn.filesend.jp/private/dSvEIFHP7NkDo5gVHcu7KPvx40OgyJYtdEr7t2_j9Jr3DyOnNMP5CTBn3oC7Ssz_/2016_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/T21Oruqu4oL1hH2Zx-gJ6CV4UBU3Iy2bOiju_tZ-R_Zc-Yv7bhYeUn5NU37FmTQf/2016_Nov.kmz',
            'https://cdn.filesend.jp/private/RNlun_JGIhEClAnRKCn6Oxv6c5KEzALjviXBh-aEpLTjZAIEh5noBKX_vdal4qjX/2016_Nov%20%281%29.kmz',
            'https://cdn.filesend.jp/private/ll_RW9FjusE-p-Juz8J2V6ctGtYoEnXixhAwv6rHHtMZPss8H93FPhhWLqcxdhA5/2016_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/bnoRxz-jyzuUSE1yhc_FXDMX4mHy_HpIzuwYEYx6Pd3NESMqNGOZ4IufXhFlkuzj/2016_Dec.kmz',
            'https://cdn.filesend.jp/private/Bmvy3MomRoomhb37QLgfT_fuMNPKz3EGhmPXv3ey8rfLqpzuqZ-sHoONmdYNjrAx/2016_Dec%20%281%29.kmz',
            'https://cdn.filesend.jp/private/AQ1kW25F9mjTtymRjsgsznwYo1LdDUCFIAPoBfX2qa7FOjlVO20aDIo2ksSdehrV/2016_Dec.kmz'
          ]
        ]
      }
    },
    {
      year: '2017',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/N70CDo75HZTDWgGZpZU3Ulvcq1J2fY3grvxi7weAIxdQiyajzq5LJ5hmqrFUoaA_/2017_Jan.kmz',
            'https://cdn.filesend.jp/private/x7yfaqMyoxJ15gBS0xvYsMAVUssnKaJzd2b4SwBe_Z8BHpC-IYEXa4VkEjDP2k31/2017_Jan.kmz',
            'https://cdn.filesend.jp/private/fs5l04qofv2NkY-P0DWxapJnWWUWGD2VLckyQJXaBsviaLLvyI13c-UdN_r5Iw9K/2017_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/WDN0jeAxrcSaUSjFg8Z6mfgISq09lqCWMAaFNCh90gFc1LN30cwaJLp8gXE6CBrg/2017_Feb.kmz',
            'https://cdn.filesend.jp/private/gJ4WoYJZJIGbO15dshPoYr3o5KfkE0FK5lm-plJnQmGixPAjWRktlvD0Xa6TwJiz/2017_Feb.kmz',
            'https://cdn.filesend.jp/private/ZygvZG7u5rjYfi7SgU2FMlwES9Auh7V2d55O3rPVD39oCMwpD86OPkRyuD5wE7Es/2017_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/9xCvFjWhLbpEHFYgFjE_1BR5AzWe8jezkMq-4pjYyezTja7xRFgzATnOXPd-Hz47/2017_Mar.kmz',
            'https://cdn.filesend.jp/private/yJIYLPzRb1vOtR0vPFrnHDNWJvbm92VGebQ8YDPh5qeqcStnyfstXtZ1WpesalFl/2017_March.kmz',
            'https://cdn.filesend.jp/private/pCzXVyek3B7ahm4k8vA3-mxi-CDI1jpipmJzAIhgKmI_pqkX2Vktsi1Ri-6aFAg6/2017_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/iTC0MjVtjKfiTBN_ytFAOaT01LJJb19RbKeoABympXP5TYLVfJ9T_LZh5Z5WnSv4/2017_Apr.kmz',
            'https://cdn.filesend.jp/private/Zk4shxQp1sh1WC8JwDYwjQH8Ky5CnJ6f-4lRumJZoeYd7llCqERYBI9OD-lNSXQC/2017_April.kmz',
            'https://cdn.filesend.jp/private/6fl2SPFvO1zUqw82qnnLYUF9lb0TMuSIZr5bOkUqk8o2bamayVZVCKs-eNopjQM2/2017_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/uSxkwmGVeHckEgjxkVa7fg6va_E51kFLRhLUYg-ZKEfgQlHrOS7hqHJJ7HO9xPKY/2017_May.kmz',
            'https://cdn.filesend.jp/private/NfnZ5Ncd29q63d0rT-8qSRrUsXEozC3dxFnjiD08q3z7500FfzZ_MaiKElBdWaTk/2017_May.kmz',
            'https://cdn.filesend.jp/private/eD4mYK09v-H4eG6tBc1fXzBOxGeJzzS_y1eavtnTuwQvhFdhZvBqi9kXroTVcKjQ/2017_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/BWLRsEzXph6_NJjIaBT7m055C1eW7TVCjFixG1EFSgLQ7pSqCdM-X0PP0uPqiKTe/2017_Jun.kmz',
            'https://cdn.filesend.jp/private/ZubPTMkMG9Ti2vthkJ5JpoQ_trpG2hhgBPuCeJJSXUpdRHRjtMCh39wMfleDZrew/2017_June.kmz',
            'https://cdn.filesend.jp/private/rW48AxVkdJHIwfTdVqjBI5bakCFh5mhHbUdascEYt8Q50V2kBFyAG4UsnAIwtrzC/2017_June.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/KBthEGxvGO8xviM64kjH-CgDAT0E-wwdme9GiXum_EGkbPldeEOSkJ8V8Xa_CKdZ/2017_Jul.kmz',
            'https://cdn.filesend.jp/private/bj2FERF5NNRGZbftcFC_IOeE0id7K7u0fmTtaE7iKF2oFkI47JT3X-X9d8-Kvgx5/2017_July.kmz',
            'https://cdn.filesend.jp/private/yWuYc1m_2AaWjZiMg0XYR1sbWOB3svP-wtmb2M6KupqX1b_-FpKgV8fR4dteZF2T/2017_July.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/WpNHd1sZWWogr6RF3wW0qG1ni3ZDLPvLpE9J_9h55uUz8J7bbRyg6rvuzW1MoJs-/2017_Aug.kmz',
            'https://cdn.filesend.jp/private/UGocceiGPhyQuqwCOBegBW60oRdic5uvU4ZFILjbPU7qU3hzMRtFpTnAIgcMc6RF/2017_Aug.kmz',
            'https://cdn.filesend.jp/private/eEU2GXtkEURwTf2cJcrRWgEQGK-zTcRzOhNBfRhbjsv2NKfEtdU0r48kwYp6bWo5/2017_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Ot_LT0I8gY42zrL-R01Y_l7FD4kjb0OXIRwdPnGanjO8r1ymq5fmpV2Ibh_XmtsA/2017_Sep.kmz',
            'https://cdn.filesend.jp/private/9dhNQzSg1fhdSg0EqHUBjkMCfz_fbQuwfWWNouVz4aip_28GBzA--dTgATlTfI_G/2017_Sept.kmz',
            'https://cdn.filesend.jp/private/l67UNKxpHGTsxsY52LBn2A8u6JuWozw2MJ8N2YrQhUtJNAaIOJQ0PyNjNDll7QVl/2017_Sept.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/0_L_8M6hOwjyHfhnafgNc136dh0X0364FG4NZBcDvtqYD5TlTVX5PkpIVDfRBogS/2017_Oct.kmz',
            'https://cdn.filesend.jp/private/UBU41riM0dc-h4T4eO7QoKwco3tFvXmwdHY-mJCWkGApDEMOJFaChVP0zY9RYfSP/2017_Oct.kmz',
            'https://cdn.filesend.jp/private/xyinw-5pknvqx4eAqmH1aDAz1aU6p3X8cUwwWfPejDsyBZPJcB09FVx1ERtvvnLX/2017_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/UoKVKDg1Qh3wG8MzXZIkvCSQGt3gLyE3bUTLq4jOksGCCPLZjWD3hcPfO1e1a-h8/2017_Nov.kmz',
            'https://cdn.filesend.jp/private/O9inkuvL-IaEWz048utnwy_Hq-9c-e6DRvjDOnbpk-sbD3LHdGzKfAr5gA2HNeiv/2017_Nov.kmz',
            'https://cdn.filesend.jp/private/5IXeCrVYTLN11Dw8-l0AuakeUqoAbsMhT0rAKjQvid8c7d-UfIuvyDlc0OtxXrhP/2017_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/bE9fjqHM0pPYQL0SaJ8Aw0NZQoG4Gbt0P12BdOxXTrnFh9eOEq2Y12halkqK5f92/2017_Dec.kmz',
            'https://cdn.filesend.jp/private/wTLk1D4zjLsIAgSg68XUc-r33JgELSwkBDtY1VEMI0E3liVbdH__0C43dvD3bZRs/2017_Dec.kmz',
            'https://cdn.filesend.jp/private/zTdOGUovUCAoy42M2vZy-zkvsyOYvRCecQqx0dL7zlFYlPb9s-MrUT4JxNhz_7hu/2017_Dec.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/0DODf3Waqozk6t_DvDRrud3kKWeht8rFrWno_ZLaKjQNCflsWrtwoHJOQC4WjWut/2017_Jan.kmz',
            'https://cdn.filesend.jp/private/hslLehCmt1rpX3sghAO7HbAtfVe3PNccURCED6oLoey3ijqOOVmcFP2gorZZv-Z7/2017_Jan.kmz',
            'https://cdn.filesend.jp/private/dioRrpDXsu-5kfUtvIp9jNrvIH-n_KB8S4gC_y19GoDIdEYeowH1vUZXbE_XxJAT/2017_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/rL2t87Mao6Boqx3ChOvNIR8bNagD0Tq6p6sNi6ULJNG5KojPAcCnTmz4MpxvbaF0/2017_Feb.kmz',
            'https://cdn.filesend.jp/private/ZsWSFfPQzuGSzDRLutQYO3aKA0tkfB_5PecflNqwV5DZP2Osj9jL0mbaFowCvdTb/2017_Feb.kmz',
            'https://cdn.filesend.jp/private/OjuI7z9ntY2WoQ4o4_TuEVAUI4kd453-Jk6d-MQD4UOcY10AzARFZsTogTDWYBlZ/2017_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/LB4Exk_EDZ6vhujZuvoJ4TlW9s47pS7maZS4cTkZgihprPJqw5hHmonJBmfLbMh2/2017_March.kmz',
            'https://cdn.filesend.jp/private/mqq5kn07RtWl4NptqDFSnfvvDLdUPeYn-7GSj9APrfBYPK5aNGhEwOd7nIbRa9Rc/2017_Mar.kmz',
            'https://cdn.filesend.jp/private/KPCWDEqoP8PpVkm_s3kMuduWcAdaom3I7th76hWwhYQIoLslQwxpBcFXDB08XacH/2017_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/v42zJnohpaP_vVBR56c-T1Y0aWEo4PDNbTae0Q9G8oXxUTjGXG1CoaVMlokFqUKN/2017_April.kmz',
            'https://cdn.filesend.jp/private/UWod3mFGC5P9gxEgvUdT0XrmLDx8XcK848VDLUgTdLauFhE1HF3BDfz2M7fcH_bt/2017_Apr.kmz',
            'https://cdn.filesend.jp/private/wxrMl0Q966l3OGlaZ90yKX4IvabrVVfvVBxfiR0Mx57v9whEE4mOi5etd7xjHUUV/2017_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/8UgJv5KVrRpBw1g3jroKkCPVZVinMXiasfp0dR3ZGirVK-fKkHKQySDjY5O6rL6p/2017_May.kmz',
            'https://cdn.filesend.jp/private/jWLDr2Bm6Kjwjtj2ua1GwkQxVCBp6ueeMjg-2nmmipexdcVxbrQrnwT7ueOcr4-D/2017_May.kmz',
            'https://cdn.filesend.jp/private/zoJJkngdaaZsk_lbE3_wqI_MhQHeMXstXy4oqRjSOB2k1Vvn_fjiMrsGthJnaogS/2017_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/pZ5arF9N2QHCKavDqgw-MpdGRzKf7WgCs3iChT--kWJ76VMpN4V14mD2JNFR6h45/2017_June.kmz',
            'https://cdn.filesend.jp/private/1o1cG_tS2mHVaPQ3AnkUa7E89x6FLc6ALOeyo6MrD0Ayf3zCvPpawnpNb0JDVRQX/2017_Jun.kmz',
            'https://cdn.filesend.jp/private/yJgnhzQ1TA0fUGbdjhtAtOSBXawuONiw-dq4K23dg0eW98vaEnjgbvLTI2aViWF2/2017_Jun.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/A6up5uoss-JUy59RSBT1ml2KU_DJEu2Qk4yw3r9WMVJq6WWPzVb8h7MHSlVnRDHC/2017_July.kmz',
            'https://cdn.filesend.jp/private/i9Z2NRlwIbXG8ywA632zjJKzY1yJ41a9ifWcVFE5ZcVZMAjrf1y4OfZ4VwN9CqN_/2017_Jul.kmz',
            'https://cdn.filesend.jp/private/W4dWLlxMKTUNoERrV-vYrydUXUtT3kVb2cHoLqN0mbpNlpfHNIwIqaTlOy32NF3w/2017_Jul.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/_fd5ofVTLMLGlwFPj9m4p0ow-Y9CGBlSnf5KmNvDFmUJk1kucTzhOFiRcYhns6YK/2017_Aug.kmz',
            'https://cdn.filesend.jp/private/tEKGCtOD04OOPgMbnbJSw--SY28PXMu2Aw-v_dg_Saf4sp7ZolpE1fZD5OOIA4_1/2017_Aug.kmz',
            'https://cdn.filesend.jp/private/gq7UGiTuUdxACVqVXFxTkoqOG7cK7SKvuhwV5Q_ThKGJyorx8hXJvZxauQTPy3Ag/2017_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/rwiK_UeuSc4RYAnaiV6UgRz65J_CA6x2fpkTztVbCRjYAFBc8oCnWsP06hfseR8N/2017_Sept.kmz',
            'https://cdn.filesend.jp/private/VK_plPdNPznr_QEqNlJqKU3EXBGIt0uPfPCK5D8aBHQoO15Zlw_RDdSfZNo67pbJ/2017_Sep.kmz',
            'https://cdn.filesend.jp/private/T4QOyLBDReqTdZQshOzKWntg5RyRrpe4CGEv_3uH5w7hGp-cL1NYAjC2Evd3JIZQ/2017_Sep.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/DxbQjHvgJ8AoWcHCzbchjlvGjyt6WcbpDaZmn2sP4ju6sMFCWWsUBBRkdRXX2idy/2017_Oct.kmz',
            'https://cdn.filesend.jp/private/IQC5uCzhceRuxIeUEAqlR6OXh67Pi07UchcuK6IsxRIKQ9obEPx2AzmpcY0cBmQ-/2017_Oct.kmz',
            'https://cdn.filesend.jp/private/XCTP3T2zOwmGLyZgk2Ksp2j5ab3cPgpG5YF_6bAzUBfwk9_xjNjok9KWk45WK5qu/2017_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Bz2Ny_W7q0wJZ0H5dtVaIz_C_QnG5gbj0gRvUTlm4_mp3IlWhNxSfhUC5oOIeRdG/2017_Nov.kmz',
            'https://cdn.filesend.jp/private/AaFqCXlviNyDdNG8ZuvwE51n7pV4HOIDqBjbTVM3vWsmGq8Jux0cTRCdm8T3oHve/2017_Nov.kmz',
            'https://cdn.filesend.jp/private/aGjwzZkDkjVmMVwzlyNsGYkU6wAu1YlMXhcWa4wOVNAD08n4Zn3SHDKGgAWiLBq8/2017_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/PRmyoT_i9SqTVmfcY3vrFlQiyxow_2JcrLWj46lLNU2StJEJ2tMU_QD3AJPc-eBR/2017_Dec.kmz',
            'https://cdn.filesend.jp/private/7unQ6IfnPJbJL_PWuDC9UoU84YhTC78BfoeOZN3JPVA4LzhNSYFWN_2hZF_r7VQe/2017_Dec.kmz',
            'https://cdn.filesend.jp/private/did_OQnv4j5CS_EDlREEAd1_0WqnfA9ocNRDC1taBnX0u_dMYY7HMkj3horoM8zv/2017_Dec.kmz'
          ]
        ]
      }
    },
    {
      year: '2018',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/5fhhYCMCoJGxdXHTN_OGrbZOFMsBrOmM93f2_Jg5w1iYmK8f-FtxZl9InTNWtYtJ/2018_Jan.kmz',
            'https://cdn.filesend.jp/private/5-6AjQe0dHGvxNKnlanDEExOLHWNuJ1V2b5hLmj0nMYJrzzp3kVSBOVYODlVFLQw/2018_Jan.kmz',
            'https://cdn.filesend.jp/private/fkI_8zGF2Q3gVMESNoTsrYeBGuZiiIv9UEdvn6qxe8BAe7i-Y5cDcp8m3yzl7bgq/2018_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/lmqMxOJlzF9u9ifR97gkQ8TGRx6b9-0KhadqoLzUPFqgTfS6Z0CFC1gFLD5xn7nk/2018_Feb.kmz',
            'https://cdn.filesend.jp/private/9j5hA8o91QpbB9bj8STCdIsGxaeQKbNT6QdJxTr1IncKUfLnnoQjCXnkznqh6lyA/2018_Feb.kmz',
            'https://cdn.filesend.jp/private/2s3o8BMno_OwtHNr5jZ55UoAbCEyn47gIkwRRbKG-Azs-m7_pDPQnW4V076WLD5g/2018_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/ZJcrDoOfin9D5WwbfBMBrS9q-MHb-xbkptm_MGhseXt3lddsJ4HJXJOZEbhA6e3j/2018_Mar.kmz',
            'https://cdn.filesend.jp/private/QppLLvgYjzAgynvEHoF7RhHTRzgQzT8uuqCcMkec-d1zU3zX-vvUJIrNLOL9rCXa/2018_March.kmz',
            'https://cdn.filesend.jp/private/S8he2vt0EBEnvkHgbm8vRlSIk3CSF3QN3KfDXnbzXWeBSd3RzGxFJEtExGg3-hNo/2018_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/2Ru0BXYQ26Z_Wg1LRNh-cvBpTh--7Cs2WbFHbX5LO3aNFlVI8ufe3GWHZZd4PbCy/2018_Apr.kmz',
            'https://cdn.filesend.jp/private/KsgmXAZrQ4oOgnGzPF3QDiknBpiK21BZty8U45KlBtBYNzZ1BpE9XDNqGKo-psRU/2018_April.kmz',
            'https://cdn.filesend.jp/private/xUpqF8lUQ34bpLGbNXzHjRcZSSX-SZRJlvyy4e5pTvUeRa1SXyDq38M1kz0K4u0S/2018_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/kCILIsQAbu1bkM1Mbumon8My8MdlNxbwGdPNx4NF5yxAwy3E-qDUdUWFSV-calEQ/2018_May.kmz',
            'https://cdn.filesend.jp/private/1jZ1zURqhwEhTWFheisIK40TRFwgULco-jJ9xdf-qFEM6jUResadIOX9TIoRpol8/2018_May.kmz',
            'https://cdn.filesend.jp/private/qhs0nrpy5me8G9IbXS-WW6AbehlymllaUXgk-priepMsempTDH5txPonZnisu_Jc/2018_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/IQ3D3GhTENP3h2gyvf_2C11gl_J0H_MObzSC7k_VZDaFZsV0XMQy2rqQFl3UhHb9/2018_Jun.kmz',
            'https://cdn.filesend.jp/private/qvED4YvEhanQVpcXgbOG_z7W74dwYW35J7hJnFHxOIC9R7LQwPKqynNYv15B6FYG/2018_June.kmz',
            'https://cdn.filesend.jp/private/WntV5UD5LtOEDEhrNrs7oSfT0avIKtQzlUwbCmlxJNF7YyGIA8o6BOsjWgUEOGSQ/2018_June.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/cw3QWd49mugQbkkX9A2mfgC9tqVttEys9ClhmO-G5Pr6p8tyunwVTTEFjDZygI4o/2018_Jul.kmz',
            'https://cdn.filesend.jp/private/i72dmry_iepRf-t4iS7IpKB-34usQVLtU6NkTQD63CgsLk50Fs25BtfONDIbqmas/2018_July.kmz',
            ''
          ],
          [
            'https://cdn.filesend.jp/private/OUeBHYDXnqSZw8KPPIjTvarGG5Tmh8XWRS32gECGI5fsuG1fl5vH7V5nYi_nAZdE/2018_Aug.kmz',
            'https://cdn.filesend.jp/private/1Jn3kNr3fuJp5YEyuzPcDcY5omirzg1SL6lGwZ7Be5ZF7g3udQlaUfYuBYQiO2BN/2018_Aug.kmz',
            'https://cdn.filesend.jp/private/rq_t7f9DOpFu_5wVkGJR0u4MBHF0kFFfYJVeNdmlvoUv0gDXITe43JiLa7BhDjL5/2018_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/NRcmN0xkpR33MGtiianjc-32uyO-djN1unMuLOiPL7eqnsSOg5gVfYvBIXq_V3WC/2018_Sep.kmz',
            'https://cdn.filesend.jp/private/f2nADliYXvcoH_FOTTnJiuvXTwSSVt0zgjeGSMHV7UCf5DuvS5IbHkhh65InAxSa/2018_Sept.kmz',
            'https://cdn.filesend.jp/private/9ctVXbAlEyhT9_KJRmoz9oWt-3iInSJXoTijwGhnJ0hhZuIb9RfgXoUti0xxK_my/2018_Sept.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/2bHHIsOZkO0aDGDDhFopFiwElWTTTg5MQmJ-pDH1HDlJIKhJFZ64P3M8LHIJZwmU/2018_Oct.kmz',
            'https://cdn.filesend.jp/private/ePh7omb7dY6cnGbcdGu3DLPCQfYsyRQuFFJQgJaTt7uW3mJHQVESIlygcsmV-07s/2018_Oct.kmz',
            'https://cdn.filesend.jp/private/wFLggy3vmWjWvcDXbkStF8i_VU-bLM8vDDee7zhqAWIHS1G73EyxBa9VtVc36y2p/2018_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/1jK86iz0x0M4E4F4hW0Y-G4cLiGAa_pn3hZMc48501wPPJAMd0pGfBaFES2SYjFg/2018_Nov.kmz',
            'https://cdn.filesend.jp/private/AH-1Vt69tE6NBl5HKc4otumTVKV-zf1hxdrhcWe6Kiq1so0FVd5Jm-w9zmAjBnAo/2018_Nov.kmz',
            'https://cdn.filesend.jp/private/aiuuWS9hp20Lu39ODtGcrhmqXYD_4VpreyRRFy2-oEpJVqYM70-hMf7QE84-UXZH/2018_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/nR0FqRXYcTiPj9qdQzYz4Il8vJr-cHtrTPelpcQrxjusnnzlQAsgpfCq7I0QUfCt/2018_Dec.kmz',
            'https://cdn.filesend.jp/private/6VnHJy--LlG6h65TpKT7T3Z4nGcwhWyJe1u49YTu-NPx3pOMhyfbkRk8r_EP-XKq/2018_Dec.kmz',
            'https://cdn.filesend.jp/private/Lm6_BB7VpiaYfnTeeqkWUL3DkCI-HnjFOSWT9LCJEBAFcNE4Xp0W-3GDJzlqdXhx/2018_Dec.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/8HaPHDBN2AiFb-0JnMHwySj2OdLF64pctUe-Qn-KI81WwA3aaHp18YXEpnDOWKS9/2018_Jan.kmz',
            'https://cdn.filesend.jp/private/dl2r9CTE4XTKJ3nw9rB93e5IioNzPC_O2nkTjrYeBcZK_hcS11hbhzWVOO4idEi0/2018_Jan.kmz',
            'https://cdn.filesend.jp/private/CjFN52lHlmYVbqMGeblgoH2JErdjSiOO8zv6HYDWsLdFR3xsLGsZdF51cjiHfhEc/2018_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/XTJckKLRESz8o-SYy2wPWntsmS3xkXkQIHvGQUBRZjyrkj2-3sJStIZQ_PuGTE-p/2018_Feb.kmz',
            'https://cdn.filesend.jp/private/YB_i8RFYG4EX1r9nwdBcg8IF70u3wqaJKXDOyd0NVxMIKdIrZNdFsx1bvQuantRC/2018_Feb.kmz',
            'https://cdn.filesend.jp/private/Q0MSPr_WvUtXHI7cf4imsZ4vLBBc1ASKM09txbSXLeV9qw9B8iKMeZdm2hBrdS5W/2018_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/QUMQ5AHSRQAM8X4ld30c8duLMTJg6weUyBF9gCpElvlLttOg507duk71jxbydmFf/2018_Mar.kmz',
            'https://cdn.filesend.jp/private/I7voTBs9K-QS42g91-tGKrCxeOBQKPmS6imKcTSMnKd7lpWobnAdqj9qVtNJn81W/2018_March.kmz',
            'https://cdn.filesend.jp/private/8SjWybN96tj-yA8xhQYSp85pzFmv0t81EjdhtNJTbm-tOdAIYGrczivNxDyWLZHf/2018_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/1rrbbVj0sDy0BWO6q9xUoXKCvDHpfsh3ppY2TtJ3fb2fVbpp2kD36d5ROveNighr/2018_Apr.kmz',
            'https://cdn.filesend.jp/private/cM8ZdHxYVuLfw2-xByrWTTJc3_xXG-y4fKeHMr-ClNiOo-AhTg9jrgXxZ7DBkZZ7/2018_April.kmz',
            'https://cdn.filesend.jp/private/2xIYfBm0xQLCdvjOZEaqikdJT0LooOpxlGLQlSh6KDS6J5Br-nhsYwSkLeukmFsJ/2018_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/wUCyOq_LPGP70pNDccVev4cIhy7DoikIiKKqCeLfFKG875cYr8YuMlSQBpIBQ4fP/2018_May.kmz',
            'https://cdn.filesend.jp/private/OvxMByHbClzq1Lxa1MC8KwNjhXyVfFlxtrJ5UTwbnHCiKO39XCHLokkfHwbJC-BA/2018_May.kmz',
            'https://cdn.filesend.jp/private/7TuD7JtuYAL2dSWbyH3txUdI6Cd9g64ZwC3SxDIOisUgvJOd81FTYil52QHAmRU8/2018_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/rdpQgUN8Q_Cl0hQ1Ysd1_9ilmxjXvECzcIrgc9nORJXzOs0LprWfkGbImNUmr2Q4/2018_Jun.kmz',
            'https://cdn.filesend.jp/private/eMPE7uer7tIWqTtHqhR3-ABbdxxpldUg0axiErkLiIGHbSQKAwZZOtQppD3T5ez7/2018_June.kmz',
            'https://cdn.filesend.jp/private/pYyVTZbQ3SO9aArqCIzfU9AxfKJWHqw72b1d5Ss6iPEVkWCwBtUXX4KEpJL5y7Hz/2018_Jun.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/omC2HPXrd6oQmKJKv3MAisay5FrQkAx6g0uwUjH95f2mdkkYurImjKNGtmJJSOsR/2018_Jul.kmz',
            'https://cdn.filesend.jp/private/17z6IzfZ767PP9NgS2zvLNSOw56y8GkPQM_m8i1AGrdF7woRJk2_hux5j8cruYX0/2018_July.kmz',
            'https://cdn.filesend.jp/private/yL8y55zPINcgEqc7m8mIFgEas6CUXfG-51bAxBWFq5CYAEc-atqlXfLBOIBgnMtm/2018_Jul.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/TOUSZIgylnNpZxmzSWcS-469M_vX1STz7FN8WSVVqjB3PJJa2U6NqzL44su-m1fg/2018_Aug.kmz',
            'https://cdn.filesend.jp/private/CtUCt9kCl5ctJoxJRO6UYjmVQdtBQ3SRclRzQG8nXIYTDOyCG85L0hRc1P031ECg/2018_Aug.kmz',
            'https://cdn.filesend.jp/private/HW3SzMFqgMJeug_IJjCmTuAhNTaBvJZcGvLSP3RPOFtR2cWxritDQe0fCfcUgQaT/2018_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/0e9FxnfUaEB4-1YO62RDm5noo8ZpQmkV_mSzQ9jUxfuK2I_JQQOO8aPIp9WJc2tW/2018_Sep.kmz',
            'https://cdn.filesend.jp/private/Gm7CavoAlMw8lPG7B-amSSKKnyXIOPv6NoDwE-KGVXmS9BO1m4N3szniE-qHU163/2018_Sept.kmz',
            'https://cdn.filesend.jp/private/tgS8r8P_tZGaLTnSR62L2iEiKmwNJqpw-nczgWlr0QeJenraVrW17EQ0neMNefqh/2018_Sep.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/YvLdctD1zqnJW4cRx_R9QF1pyETJy4LN2Uwlpsg2uHGwkHMvXgPhF2_KWPcfxCyK/2018_Oct.kmz',
            'https://cdn.filesend.jp/private/9RvjdC-_oGjcydN7L08TSJkwN6gz62KHB_6yBMWXUJj1YWioKyVIyShtBL87mS88/2018_Oct.kmz',
            'https://cdn.filesend.jp/private/DwrNiWGJwHUkQg1tm0bYrb_aHW8eK432huFi6wznnu8-tf9ar8ZxACuvvucJYCpM/2018_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/DjSIl_gkghogqkeW76zH9hfyFKOhydNo4X5fQiGC4GtWv5YlvxJ-NGRhlFQrjJGg/2018_Nov.kmz',
            'https://cdn.filesend.jp/private/Xaxub8brOXiVExQTVrp5-DcmXJlDAs1z1uEt3-vsnck68U78IScalZasJQl4OANH/2018_Nov.kmz',
            'https://cdn.filesend.jp/private/ps8946lMG-SMDGxT3nROYDKdXl9xLv23Ts7Zczqgersz9Q-XWiopmMe0gZSEVnBB/2018_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/xYmdB_PVQOpzXRAERBenHKe47BUP4a0phXjsZK9wTVAdSPivLmkdYEWDCb-qZlXg/2018_Dec.kmz',
            'https://cdn.filesend.jp/private/1PjDQRxmyDWLyywtdfkC9OVhwJEYmgAtPryvQytRdVljMjXGyml9Yu2njUStB22-/2018_Dec.kmz',
            'https://cdn.filesend.jp/private/5KRGAZVd9jYjBiKSB0pv4VCuVez83xOivP959qLVybfVCHwjZ1VvLoTqKaWgaHnl/2018_Dec.kmz'
          ]
        ]
      }
    },
    {
      year: '2019',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/cv5_XGemH9UFYKue4LgqHWTGSh8G1cuxsjVj9pH39dlXngGIml_kJ_hrQiasmmPE/2019_Jan.kmz',
            'https://cdn.filesend.jp/private/Q2ejXEEXw-rtYAbAzhq16iHZZfVuIIsfqCpgYSYyj-qYuUzVYFr-x11XjyregQmZ/2019_Jan.kmz',
            'https://cdn.filesend.jp/private/yIq4hP03Fpnluce2byxuKq9I868OOd1qkRN2VNRKI1Cck8wnT_ZR9o8i4LKY9Gm2/2019_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/E9MN45I3DQZAug1TlFD7jpRHCGXjcHcO7uOvNGe13Jppz0f_k4lH09Zfqt8NJ_73/2019_Feb.kmz',
            'https://cdn.filesend.jp/private/pS53U5O-B-Rktr6IwztWgAg70-iXUsQEupDUPFTkCsIlCkiauD7T-FuKUh-H4-ee/2019_Feb.kmz',
            'https://cdn.filesend.jp/private/392rus5l1MWLLf-_DBjGgkEeW8XdMRBr3pgxjftp1y4uGbIvuwWUxsNyDg30foLG/2019_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/ysJRQOLaOZm1HchJMqG8YVfm4_RueUQSz9C1Pqe6oIHNIxWf0tI12-9Ay4W203oO/2019_Mar.kmz',
            'https://cdn.filesend.jp/private/VqdQgVsteYWQmR1cjYTDK3TPACMs9LLbp7ZdFNFc-Iph6sZWAtefSKwVLlxdkVGf/2019_March.kmz',
            'https://cdn.filesend.jp/private/zFiLwz9l5qL7Tf3uW_1tv_zL60F-Fx0_Ef3giif3c7N15GvR8munBhE21JHRjl6q/2019_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/osJRPZEFwh_vpx__zpZVdkiBz_EEy-lweb_NrrJN-aM6q_Opp7BHMB3GRveDnlVc/2019_Apr.kmz',
            'https://cdn.filesend.jp/private/nmyHdzu_OAOQrE7_QhxEuy-HA-_vpVOu5HR7Bfgheqd3Y-zZMUYO8ERQJUP3ctEF/2019_April.kmz',
            'https://cdn.filesend.jp/private/vwx_vWx1_44lzCzBncZSTeT05TMr1CKLLidhborB23fsKsJg_8ck3iI0GpTBJMzk/2019_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/0nq1qKmBIzp0-S3jQBJRylBEkzwl3MHwmnvC9Sdpu2ttA5uc9OWwKQzbI-j9lI7p/2019_May.kmz',
            'https://cdn.filesend.jp/private/usltPUwmi6Gs4lFn8aUVEU_n0-HCzGzBc1mwFrewXw4PYk-N6ARNGz3UcmtY5e0Y/2019_May.kmz',
            'https://cdn.filesend.jp/private/PVT6L-Y92JLZCu4du19X0yswtZUtZn1aiOO9a5_x4H_bGyyiERZBMQ7QknYHh95k/2019_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/FyveRsv_VfBDwgMs8jexiqRmjhejbl4M026HvjBfx7pP1Ogdsbc1By0pl4XPKI7_/2019_Jun.kmz',
            'https://cdn.filesend.jp/private/m1y3qlequGQQY945oqlMBDWsjfBKIzDN7DethsfK-K-cgiB3Vo_JbGiAkqy_7BZf/2019_June.kmz',
            'https://cdn.filesend.jp/private/wYqrqM-HRuLm30bzTe1zM0zQN64okrV0AzDJhBYnNG0px_YH_v-BdtTCznceUPWb/2019_June.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/nybyeUeRQd44IgMje4V3WVhD3LLjYwJzgmHEJAhvxv0XIAbKlUsAZs_uSyw39MP0/2019_Jul.kmz',
            'https://cdn.filesend.jp/private/H6IAPwIz-_aTi5i_ViL-ianoTYNVDbAKnD1DbPwn8DsBWhO81N1TmnKLZBAvGDMK/2019_July.kmz',
            'https://cdn.filesend.jp/private/1vY2uNyzNCF1dlSq96oXClDiB3pNVv4YjiHIsaw2UHEkL4zjlPVgp1icLVBnAUjn/2019_July.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/N_WRqjePevv1XVx0QC1ZPyDmoE7zqVJr9l7zgyAyM7WW6x10QOu9zCVccle8UETI/2019_Aug.kmz',
            'https://cdn.filesend.jp/private/aKcqTuqt00Rx-iIU2B5hmQ4P8O_tJBgyP30zvUhNiWL2LOtU6TT115pNsbnngoKl/2019_Aug.kmz',
            'https://cdn.filesend.jp/private/VGee7GBfTUS6SvO_61LXYuRj04YMWIdvBNj8usDCKfyqoN4soX45s1t4q4KT7Zv-/2019_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/2MgmM-XsLSMmgei2z8iKWntVI6e51dSSS7rvfxmKCqU6wmY2Pldjo8MaZdD7hHV3/2019_Sep.kmz',
            'https://cdn.filesend.jp/private/hKSgkxSPBW06RgPUTsNHMe9VAAgoROAZkYxRnUkVSeNJ6oceywnjI2b1a6xYFnK8/2019_Sept.kmz',
            'https://cdn.filesend.jp/private/M93aOy8efoNpecfpMQCU7Z-A6fTYDafJTCSuiXUFpeOpBIKO57TgnI1o2HEiy1lJ/2019_Sept.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/AGZoT6S9BBDQ0NxxhkqUa5G_rZjzez7CYrsePoB9xZcKYG2x2kJHJu9mt7nt-Q3u/2019_Oct.kmz',
            'https://cdn.filesend.jp/private/Wal59E7nIMNvMzLAkLBvQKztcxXWxEFmR7ky0YEcnzfqxtlKsPkTB2FhaFVKggPC/2019_Oct.kmz',
            'https://cdn.filesend.jp/private/3QKCq_TzQzRPUfuPBcofS0KXbIhqgyVqx2dZGYaI6uon_FUvzpnoVBrK6dh_Vn5Y/2019_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/rTb5qIlgth9xd1nZ5l5BKg26H5wSdCv8IWOBR6AWy_dKsoFI2_4LASPJAeSLrSAk/2019_Nov.kmz',
            'https://cdn.filesend.jp/private/99wO0xJIvySaSPdCcM9EJjMZ_9ZvG7F8GNhQCw7W3PZNRR8uwBDAQHy7E9m28LoS/2019_Nov.kmz',
            'https://cdn.filesend.jp/private/t-w9UA180FYuMl_aKvNRSc58gP_d08f1oFdDwS99RZlFAquUEphsJfgxT-zPdn71/2019_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/UZjxdeUbqVZhw1dJHcTcGGY2KoKpBZW3O8_4l8qvMDmGvOBe1926L9m3T0IcxUFD/2019_Dec.kmz',
            'https://cdn.filesend.jp/private/z_eyNKnisOY4BMOEfvUWJY4a9RBRgQ_TzU8hVZJqUnRienJgwbxGgKgN_WV7_S3t/2019_Dec.kmz',
            'https://cdn.filesend.jp/private/T3MVwW3LJ1cCx1h72pqSKZkYnOswcP9fj_QFZdF_tSP91ahZfu7UiyQRPR66cmGl/2019_Dec.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/o2GWqHZ5QA6YaVcFC-Q_8SFP02P8l8bBHPgUFT76PtuOQQ8w1C-uqr4-lmB1GpLw/2019_Jan.kmz',
            'https://cdn.filesend.jp/private/o2GWqHZ5QA6YaVcFC-Q_8SFP02P8l8bBHPgUFT76PtuOQQ8w1C-uqr4-lmB1GpLw/2019_Jan.kmz',
            'https://cdn.filesend.jp/private/nGU7f__HFBU-Hc8q-iWpD3OvTCYO2nqS4LZgWaFnGDCdOUFxzbNIjce9Qr7uV1Wb/2019_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/JYxQR-1f7-KEK1WtgrwmMQQT9xT7RAQ-zBjnXdgFQLRCQymccueyr0Int1_VLmg7/2019_Feb.kmz',
            'https://cdn.filesend.jp/private/JYxQR-1f7-KEK1WtgrwmMQQT9xT7RAQ-zBjnXdgFQLRCQymccueyr0Int1_VLmg7/2019_Feb.kmz',
            'https://cdn.filesend.jp/private/WhSLzgw4v20_wxwijb8Z3v8RqqBcTf6FncEP3m_yQqWrtUk3F49nrpYb-sACLZkc/2019_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/mQgQkKvU9loFpXp5JKDm5wmYQogZxx1i9qNJ8k5o9bxBoAwCMxMRxxe8BCMiBm42/2019_March.kmz',
            'https://cdn.filesend.jp/private/mQgQkKvU9loFpXp5JKDm5wmYQogZxx1i9qNJ8k5o9bxBoAwCMxMRxxe8BCMiBm42/2019_March.kmz',
            'https://cdn.filesend.jp/private/udi3kX9KHlbonHe3TohDwgHu4Ftb9c2l078emt7YHHs9IiqKn04n5cA6ltrfL72m/2019_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/XevfKoK0jF0IQojpkmg2Lu9OV-EhQgqAMIUS8eRn1sjHvGhZlFBQt6eqOXTPTtLr/2019_April.kmz',
            'https://cdn.filesend.jp/private/XevfKoK0jF0IQojpkmg2Lu9OV-EhQgqAMIUS8eRn1sjHvGhZlFBQt6eqOXTPTtLr/2019_April.kmz',
            'https://cdn.filesend.jp/private/DNcUxvXrBq1W7hmDkwpMhnW2kA_PT1pku7YjtKN9_Q6CYX33qb0XTD8w_t2RQpiY/2019_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/F_F9DLZmWnU0w7D2Td5U-4hQqOh3d0T58FJ8_Vg8P-7IWVsAAj_5ha_JQ5Zq1hrt/2019_May.kmz',
            'https://cdn.filesend.jp/private/F_F9DLZmWnU0w7D2Td5U-4hQqOh3d0T58FJ8_Vg8P-7IWVsAAj_5ha_JQ5Zq1hrt/2019_May.kmz',
            'https://cdn.filesend.jp/private/AwNXY9tGFMzZePBtb9Hap5YYkTb8SQMwjbX2zt-S7xU-bje5BT41__C1GV7zxGjB/2019_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/-35XSpGxWp3Y52T_4qXcdfUJke9-agVhU_D7wQ15oXLP94RsJirjuTgxhO2L_K4G/2019_June.kmz',
            'https://cdn.filesend.jp/private/-35XSpGxWp3Y52T_4qXcdfUJke9-agVhU_D7wQ15oXLP94RsJirjuTgxhO2L_K4G/2019_June.kmz',
            'https://cdn.filesend.jp/private/hLPHqm3rqbP_AjuYHZziswbG5uN48FTldPhMz28VqVPlDK1x0XcezDmYNfwmO_iF/2019_Jun.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/0cEQMevq9UJOkv-8f3ErltKitCQt8dkMnCdP3pRjQGuBPVQA5vnUgPC8SgUhxBuS/2019_July.kmz',
            'https://cdn.filesend.jp/private/0cEQMevq9UJOkv-8f3ErltKitCQt8dkMnCdP3pRjQGuBPVQA5vnUgPC8SgUhxBuS/2019_July.kmz',
            'https://cdn.filesend.jp/private/VO1CtxbZIXJx4sQUKYJMqFC7JfQuDf6sM9esXquwcpYo9kenBP7QEfXVdya1ls6r/2019_Jul.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/sPE27H4ETiwgUUzNy_B55Gc4j4nqMSrxStE3TGh0Bs8r2AXQEK3kkTMLr7NQj9rw/2019_Aug.kmz',
            'https://cdn.filesend.jp/private/sPE27H4ETiwgUUzNy_B55Gc4j4nqMSrxStE3TGh0Bs8r2AXQEK3kkTMLr7NQj9rw/2019_Aug.kmz',
            'https://cdn.filesend.jp/private/y6KbavT-Vjfd7jBQ6q8K_5ZTKVa37XK212A5xZXSSFvfYwao9Zd0bvhlgtp_CbWQ/2019_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/jGhuZ9sW8Mn_GtPMILOFmOTMPiaCeyfybm_X8MBrmCzPk2SwT0Wicg9W6x0i9ZJX/2019_Sept.kmz',
            'https://cdn.filesend.jp/private/jGhuZ9sW8Mn_GtPMILOFmOTMPiaCeyfybm_X8MBrmCzPk2SwT0Wicg9W6x0i9ZJX/2019_Sept.kmz',
            'https://cdn.filesend.jp/private/woc3sYqy4uBlc93ONPnQ9qdkQ0waFX9FdLO5GamKhEHWBA1SOVrft_JriNHJ_3P6/2019_Sep.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/IvnxQiYwBIkJPmcu-Ldu45oCgsblXY-SGaijoSgwNDSW7yjaDd31JeLXzxF_tQxb/2019_Oct.kmz',
            'https://cdn.filesend.jp/private/IvnxQiYwBIkJPmcu-Ldu45oCgsblXY-SGaijoSgwNDSW7yjaDd31JeLXzxF_tQxb/2019_Oct.kmz',
            'https://cdn.filesend.jp/private/sa0s6tyifjfO-vftFXgL6xaE02620rP2bme20X1MOFvLF7ybxABonmCXKbqK7KqK/2019_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/bBopRk13zpjEfZEjkOWdgh-N2YipwahUyDammGuF13c_3gG5j40UImOHvp41xwAd/2019_Nov.kmz',
            'https://cdn.filesend.jp/private/bBopRk13zpjEfZEjkOWdgh-N2YipwahUyDammGuF13c_3gG5j40UImOHvp41xwAd/2019_Nov.kmz',
            'https://cdn.filesend.jp/private/8S-ctE8GdVN_N8UesybwLV12G8TjyszB-GLqZ4OGdUXW-UzprxBkvltOXUYU480I/2019_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/-OoHkMGYsWFsn_0EAvwbWvoT7nvRoLaYFZPCXeVOcj7WlfeqrRXcH7ZCkgrSNtNB/2019_Dec.kmz',
            'https://cdn.filesend.jp/private/-OoHkMGYsWFsn_0EAvwbWvoT7nvRoLaYFZPCXeVOcj7WlfeqrRXcH7ZCkgrSNtNB/2019_Dec.kmz',
            'https://cdn.filesend.jp/private/3iocQQD6uDGfFXiucE3FBAD9Blc_5vbsCYilpx3feBzdP13JaYDM7M8dhSwePuAE/2019_Dec.kmz'
          ]
        ]
      }
    },
    {
      year: '2020',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/IL05qZ5Wa1CUifVAZ2uq6VmogoNYXwEUadMsOkgJRR64jr3VN2AW-FdB6X9-9hSq/2020_Jan.kmz',
            'https://cdn.filesend.jp/private/jycIomq_luXS5MaRsf7EsFMnIbLr0OabCpnxAFT7DmhVGTzs7emAf6Ogdnpb6zEZ/2020_Jan.kmz',
            'https://cdn.filesend.jp/private/lObolV7Tkzkla9c6YCrRmSMF77mNRihhShYYjHmN8XUrgCWB65jLqoXmB3Mrv4Xc/2019_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/c-YHF6g8JZDETqSOG44FNb9SYG_FKeZFvfVVeJI8R9irOQ3Bbo_QCdL5dxi8ABvw/2020_Feb.kmz',
            'https://cdn.filesend.jp/private/057FW72SHs06TRJiIYvGzIBvssqPX1aIkUODtTGfkjGjufMjbsVV362nEQ3A3YXc/2020_Feb.kmz',
            'https://cdn.filesend.jp/private/JYxQR-1f7-KEK1WtgrwmMQQT9xT7RAQ-zBjnXdgFQLRCQymccueyr0Int1_VLmg7/2019_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/VywKUSkdJV69-ZaExQOosNns4BiS0B_rRILz1xFs8VhWlca0gmByqUMsI3Z8-io1/2020_Mar.kmz',
            'https://cdn.filesend.jp/private/v5aYydH1DR_K5bAmKGzi1hVbNuH9kIAySvaUcPNsE0c9sfH7YwvwWa6SMKhUiah3/2020_March.kmz',
            'https://cdn.filesend.jp/private/mQgQkKvU9loFpXp5JKDm5wmYQogZxx1i9qNJ8k5o9bxBoAwCMxMRxxe8BCMiBm42/2019_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/J5iZOzjI9j_tfmUyxNBiWxj4I0Pe-ehn0iYlw5vvnhCkLxc328waTeSsma6PZV5c/2020_Apr.kmz',
            'https://cdn.filesend.jp/private/HOTVStV9GW2ssJiz18MME25QK6JOFMgPhj4auphWB2dot62D5qele2EJBqEOH0EU/2020_April.kmz',
            'https://cdn.filesend.jp/private/LgmwUBrAMkPgm7zg3wO1K6cEQbA4Olem50crXx9Og8GNqyVLh4iU129kk3YBgOQN/2019_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/NfFUO0MPJKRw3x2DDkPha77Hb85sYbBtrtxTrvRa8mwwLC668WIBLp0WrsX_1rW9/2020_May.kmz',
            'https://cdn.filesend.jp/private/dAss3B-TO7ppxJOtKk-JCOzVJQ6-cbIORxdn8NABOHZQNonlDBE8EeZUVVBHpEe0/2020_May.kmz',
            'https://cdn.filesend.jp/private/S3TadYSNTS45CAtxQAx8DEtIazEf6q2r_RYrkcUcB1j39KFeGhG56BrIVVdJrqcY/2019_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/FHO3ieck4TaaajhOQB_D237GTF6uCIbbU5aXIwPuesO2ehPqHNr2RNmXXd58S3y0/2020_Jun.kmz',
            'https://cdn.filesend.jp/private/HM1wBEH2rKSYoBFeo8EAa7k0PhXxM8NEHWwNrV5RgAIYdB5cBxPp-R4d8IJvJzLV/2020_June.kmz',
            'https://cdn.filesend.jp/private/-35XSpGxWp3Y52T_4qXcdfUJke9-agVhU_D7wQ15oXLP94RsJirjuTgxhO2L_K4G/2019_June.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/VpFvmf2zBvWdejAfBV5NWnpu4HiCpfegZyaPkEjfsaZJwG33mK5q4wmRWMBRY3gt/2020_Jul.kmz',
            'https://cdn.filesend.jp/private/9-hrP43ytl12PDqeQYSQL3Pw8wdwYgzqtLkhbk794fprvkKpmkxOEIatLLjBAzN0/2020_July.kmz',
            'https://cdn.filesend.jp/private/szV-rscFiGWeSDVEbLMaQmRIRRunXh_Hg0K8VnD4EpV7DFIR8YvzmhlELSsqndzc/2019_July.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/jujXTFIZNaXr7y23ee3BkqmE06vbFTFffG2Vt4diNdd7cgDVE2B2NPaXs9ZpeW6E/2020_Aug.kmz',
            'https://cdn.filesend.jp/private/WIKmqm2D1dfA_K67rGwTauQjmxA7PdcvFO7cgTZDcd8-M63Xy1GscPQIj4eXrt0Y/2020_Aug.kmz',
            'https://cdn.filesend.jp/private/37Vm8Eh-5qUA_q-V_aperEmvZjobk_dw6QkZUvvi-h_KCcbHbBJFhU7HVHBAOu0i/2019_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/KWpPp6ZcKujaa0HwXr36gg2hYXfG2H5jN-JBKlLJ-4lA3f-1NCKt_igS7R6P19FO/2020_Sept.kmz',
            'https://cdn.filesend.jp/private/d7omPsrpjeqY_adlBtFJYblz6ME1YXyEh3Iyk2-Yo9FXM1hOJPXrJHgIQpD9hH8y/2020_Sept.kmz',
            'https://cdn.filesend.jp/private/jGhuZ9sW8Mn_GtPMILOFmOTMPiaCeyfybm_X8MBrmCzPk2SwT0Wicg9W6x0i9ZJX/2019_Sept.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/r99hajdubuH6xZCw5pN3SjSv3VfLghNfWlZLeBbqSw_9P0cdiibawuFpGK94YT0M/2020_Oct.kmz',
            'https://cdn.filesend.jp/private/QgpPNLrnj0MzTEvbRujNOu3vhNQiH6_anUYUNMTQe_et12STlY7KSycpSbvvM1pN/2020_Oct.kmz',
            'https://cdn.filesend.jp/private/PFpVfSr3mMnhfCt_EQl0gBrgD9NcG7LxU-4YKJM7jdHLjH2xA1C7pU4xB8DEjLfs/2019_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/6b6rR5wcarlv9V_gV3_BG-dYF3XstdRj8AWSbYxWYPLs7cLQh5Bp7IncFxm9df1Z/2020_Nov.kmz',
            'https://cdn.filesend.jp/private/uZvGPBMaKjqPccR20HA-y47cSbftg-NZSzssPvX3oKbk87BQYaVVkgJ4hyt6-Kub/2020_Nov.kmz',
            'https://cdn.filesend.jp/private/bBopRk13zpjEfZEjkOWdgh-N2YipwahUyDammGuF13c_3gG5j40UImOHvp41xwAd/2019_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/W_tnUGWhMI0LKc4wq_Vxgg5m8wgsjBISvVRfYMAZ_tRaSWUPUtFT9xzQwbwv7b3R/2020_Dec.kmz',
            'https://cdn.filesend.jp/private/dOUcUMyJp7l9bExRrDqx5M2AejKlXz5UzRQD1fqVfOhiM8SNce-ZJ_O6NekmqSMQ/2020_Dec.kmz',
            'https://cdn.filesend.jp/private/-OoHkMGYsWFsn_0EAvwbWvoT7nvRoLaYFZPCXeVOcj7WlfeqrRXcH7ZCkgrSNtNB/2019_Dec.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/knvLgLDC8HzNyUrDy_YF-__llWJi4TwxLgIBuEh4qJOv8SSDDg6FQmcfyhDYh2fE/2020_Jan.kmz',
            'https://cdn.filesend.jp/private/kcvEuAXLe9Zz4sOeiucF3WAtvhu0SvA6Jup-Ej5D6zVbPto5lrCU6AVmNEwGcAw7/2020_Jan.kmz',
            'https://cdn.filesend.jp/private/8KES-qWYAwHaaMB27M0sC5f-sSE2E-I8ep3mkIP_xgokwcI7Y-FEnxun-hAlisXf/2020_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/gq3BClh6uM-FV6jSg3ji_YFYEtekNyfxtOm3EjfTAPOmPPK5_8F3d7Thzhw90eJH/2020_Feb.kmz',
            'https://cdn.filesend.jp/private/6M9L65n_3DuZKvCyv1x9XiPs-mhtqCDC_wifmEx-9s0Wn0y49p92RVQmeafVJK4K/2020_Feb.kmz',
            'https://cdn.filesend.jp/private/fkXdi5Oa4Cz7Wm0KO781Ll_VI_8HhYktsUTRLvfoQnmeRM1PArWls8O8tlIsymrD/2020_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/KkndGfADTsvQO20rTNVnPh7Rz6mtp_k059Ts-cYqytiVQEvdM8b0iRW5J3XoE5iO/2020_Mar.kmz',
            'https://cdn.filesend.jp/private/CIs6yunF2JYPPCeimR4EFDJZ_1HrKfz4V6OQKlRSg8jz2cq9hl30-LfHzDpJ-eZd/2020_March.kmz',
            'https://cdn.filesend.jp/private/ps6m9i5abMtJNKR7anKrOskINe9I_UBd44z5Rcp6L2ihNOHz-30wU2C8rwXDgYG-/2020_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/W6N_iJ7ee3tknIlhi8P3OEMDbsT2fqr22WQIAchdx8OwOYfH8cEZ5CJmedCvthBN/2020_Apr.kmz',
            'https://cdn.filesend.jp/private/F_49rjsd_MNMMn37Kti62Xb-LKmOdwAx5ocnVeed7dOJv-TEyqps-USIzBgXsTgQ/2020_April.kmz',
            'https://cdn.filesend.jp/private/3aTFVYSi1rzQkBKl_WGj0Xf8aZxN5Rd_dNpzD94N7_7F3r6zxD35gdgsrS6twye6/2020_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/I_whBvhh4CENrSr_g_nP2l1ZYJKxiPdfZmZlkX99eqmU5XPTAmBgbK5J4SSIiBy9/2020_May.kmz',
            'https://cdn.filesend.jp/private/NMo4W8oPCArIu6QYbJbqN70TR4Tu2GV78G6H5H3Of1YdVrB0InCkMP6zllWTsYH6/2020_May.kmz',
            'https://cdn.filesend.jp/private/_yfer8d-R0TjmYnwTrYiwxx1-1Xeta7yt0y5mHp6jUfD__9v31r_edu51RosmjPf/2020_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Rku-dLEdMlVka3-MWTrKFml1M11IgjaOZs5u7bOyGSI3rXU4z-SiB_NqIujtjxeF/2020_Jun.kmz',
            'https://cdn.filesend.jp/private/UDB6wyaiqWXO1XaVnBnH0g1tSJBabJ7xVkIi18PL-Emvn46B5nJ3Yg1dlig-ld-x/2020_June.kmz',
            'https://cdn.filesend.jp/private/W5_zrAs-AZ-bjueoZMXnDHZtaRiNXA8JzatC2MXJ3NC5i_Fqr_xe9sDW2eZBjMwd/2020_Jun.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/sd3T3aeGKPlMaEJztqsTZEC1i4FCV1InEYVIXiEA9DZa-4ALjskMAm07LUNrkkSU/2020_Jul.kmz',
            'https://cdn.filesend.jp/private/r4egRLWmCb9UEpF0VZRJ1nblkmPNdREQPdeTayhOe3DZZ0JBMu3srZoelVPRd3Um/2020_July.kmz',
            'https://cdn.filesend.jp/private/hJcJeaK13CHrof0Ax9hufs4VU7Q8lAGsrp18O5WlPtyHBLg61bihrUZ9Xq_BFzvi/2020_Jul.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/VJ-9QWuKx95dKEAKov3QBEgvBxMPfbNhR4Wd_lSK8BF-C9eWoqLtoAddc3c-MuAm/2020_Aug.kmz',
            'https://cdn.filesend.jp/private/LLY4XtKruO0Ma9bl_vb91YUcXiQHDZac-Rdw7_QrCZXbIrnHgmIefLlz1Gspp1ih/2020_Aug.kmz',
            'https://cdn.filesend.jp/private/0zQXuNQNF-uW_o4ppEW-ls6B7HSwwCt7a5CUrz0ShlpgYcGVLILMi5LCljlSIY6C/2020_Aug.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Jjh87wpdnSnPRzW7BkDmt2d-J0n2O-cL1PVM-fPWWKY8eCaM3sJFZurRECF9oEa_/2020_Sep.kmz',
            'https://cdn.filesend.jp/private/ZM_x2Ju1Czmm1reRqolH-yePVtoTsdZ6FFOQ_S3LZ50QTCZK8p2ZJoPwFLBkow1i/2020_Sept.kmz',
            'https://cdn.filesend.jp/private/XTtjjdJ2jN2PUePU3mySVD11U6ZE4cNiPDIkYgZHoQ8bpfKR7vH0HIil9bWACcb7/2020_Sep.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/2NZSwlmzkNjIoJjDCOhKoOsrrnYgYmPzZoeJcuSV_2ewZGLk0QGYm1VtYHoLl8he/2020_Oct.kmz',
            'https://cdn.filesend.jp/private/RqX0bUoHWFGHVr4tFH48ohAAEFJBXd1UC7m-uEgpCK0XCy_RDaz9SwxlFrvri6Y1/2020_Oct.kmz',
            'https://cdn.filesend.jp/private/mpcP33h51WT77tOLQ_Zu47SRsfO0SWOygiiisMnu13dIfZWTCie50oe5nLFN-mrC/2020_Oct.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/mQD4FfU1LETdkCZWic3KsHlFSp3Tb2mrpjNdFOdRt24b4BKnrfCFAEfzdIYWhY5_/2020_Nov.kmz',
            'https://cdn.filesend.jp/private/FBTm8oInB7gyIb9NoFMyt__wrd5q1hR0sEzj_VJitM_RfotEjyrevdjs-D_3S43Q/2020_Nov.kmz',
            'https://cdn.filesend.jp/private/3nFBQy7UtFj-RIdYzXVUCZ_M1aiNjK76YmaHbQ15uDge_bgbVbSn5iV73mPNYWk_/2020_Nov.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/L7kCZ8Oz0Qhs_xuQZ5zAnfiKq8WfLDE6eggo0tTxQxeQNJRxtJgDaCnyoAhWr-EF/2020_Dec.kmz',
            'https://cdn.filesend.jp/private/p9kDiuxz2Y6259cZnjkNjIqpjAH1bczkICeoC5d4AAOVUda_DZSUvwAdAcYIxmAl/2020_Dec.kmz',
            'https://cdn.filesend.jp/private/XmQVmsS12sPKqWj6WZEeb7cZYX-WlQ67uxo1p2jSI6R8UEMiIS-Zxy1WbIRrGvtm/2020_Dec.kmz'
          ]
        ]
      }
    },
    {
      year: '2021',
      data: {
        chlorophyl: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/p5BoVTFm0NlMKPcDjWuOS3xvIs0Wl7EQp5C3NOG_6TEUrHmJub2_7gmOALDYw6Xw/2021_Jan.kmz',
            'https://cdn.filesend.jp/private/PHIvi5fpab5vzNjPFFjJYDUELbVQgJvMj33evrF2qescvHNvGu_zxFqcAoZmFv2U/2021_Jan.kmz',
            'https://cdn.filesend.jp/private/BluTUlD1v9IXuCA1lAb7oK7QMnFNo_vFIalwLVc-tF6Oc4pFziRFWPTxMqi_spJN/2021_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/6Gt8dAft-gBcYKVBw15As15TkFs07wZJqfWpqdSdit_-_8hfjT2PNfyItWkuXj7K/2021_Feb.kmz',
            'https://cdn.filesend.jp/private/geDUjhGB4BRVv5wzeX2sofSmWB6ebNWZp6gplH0doVxnUXr0a384j4UiQSrj5dSR/2021_Feb.kmz',
            'https://cdn.filesend.jp/private/c117oQE_CkKN_mwqiefVqJWdx-HuTyHPqI1jB9zH37CRwAw_AgDeTaDXAeRvhAY5/2021_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/QdEYIDN0u9K9pW-1sZOBXx5Ts78IRK2ujXZSNv0dgJJaogz5AgYZTN1-yNHT66fQ/2021_Mar.kmz',
            'https://cdn.filesend.jp/private/CM_OYZNqi4tFIxBAO8MeONMhm8dC5aI5TCba4tTfxyFQ7Oi36oJULZ3txtliJ0Mv/2021_March.kmz',
            'https://cdn.filesend.jp/private/Z8D7G6JXwxVFXgp5lDXKLsNTvZofKvkfh0FAZTDl9OAmJyZ0y9YEHqVG6f6A4jwI/2021_March.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/SVrEOSlt0WPWWJkVbLCEer102qals3rXs7GQkSKwWWaX_Gb68eIyEYtK5JPIU9u-/2021_Apr.kmz',
            'https://cdn.filesend.jp/private/_vv3qFQkaiz6i-r9XPnNmVmWxGSYCx2de6NQDTpIhFDsty9MxZ5o3jQkUWt2z6zu/2021_April.kmz',
            'https://cdn.filesend.jp/private/IA6hPmUzDkvU46-s4NgjFXT2CqZYquuU1YpzSP7N7fi3DSn-LTWiIJJKGg55WeYk/2021_April.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/5Ezs1WYHUymN8F18PttW83PrLVg8uYhlvCK5jZyC0S4Z54zR94pRMPzN7d9HLeFm/2021_May.kmz',
            'https://cdn.filesend.jp/private/-szxPWkrfUo49JoU1wpdI9J84x4wgvBYJjby1hxMYDI-aipqM3yvD9w7Z3XTKbHy/2021_May.kmz',
            'https://cdn.filesend.jp/private/C6ADqdKPmLkRNZD2KT49CiHXZVPIWrhEgIsVwhwz2osc4p_MA5L5_vJU57YZhrH5/2021_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/NOnMK8lfIFiL7lwvmz4W0IgnGimSdSj61QqOno1I2OCThoZQWy1FYXjREd-nuOoy/2021_Jun.kmz',
            'https://cdn.filesend.jp/private/aDlYQWJSVOfewgxUHb1cwNzrbS5HXU5ca0Bx8rb0cPBXmwuPRSmmIbVwyNaBavq2/2021_June.kmz',
            'https://cdn.filesend.jp/private/AfCOPgBKJjJ-6a2kLrHVdDWif6MW67vVUPNnreVI7qFrHUbcW_jVLYwIKmVTdOR9/2021_June.kmz'
          ]
        ],
        sst: [
          ['', '', ''],
          [
            'https://cdn.filesend.jp/private/x24umi8FB2-VeAXy2BZPK-ZbkkudMJo2h5sBfyBWwggWjt7JxsovAAk2HJiD0Wbj/2021_Jan.kmz',
            'https://cdn.filesend.jp/private/Plf5uVNBYz2PF-bUbk-ayz_jpwRA-I-UhtOhPoA2U3Vu-O_cSdt4a-VqURDkThS-/2021_Jan.kmz',
            'https://cdn.filesend.jp/private/5JFzCTET7IGSqLnu4QsulZglo72PPSP8B3bGEn7Ec2aLuq89_7NBjQHwP-tSwId5/2021_Jan.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Pm_qqb6glTQQg1rw42uZSIRM0c4P2_0sjVkN1OTAKIQCcw-UR51vitbso0lbhztP/2021_Feb.kmz',
            'https://cdn.filesend.jp/private/JdSONbEB5rxwFzodscRZnfYuDOzCuTvB5bCK2yHadEXmZDXoXDcsRVwpTxxVpqhu/2021_Feb.kmz',
            'https://cdn.filesend.jp/private/z4gI6-b50H0lp7lvgpT08kfroQY0IxWxPa5cn2ftm77z1-JN4KSlITtfd9XKZQWd/2021_Feb.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/HfeSMDD8rOalu1bX12Atn3C4MeSLvgrlSS1lTSCCaB91FNVY3R8Jj7-9ZbxZzRlt/2021_Mar.kmz',
            'https://cdn.filesend.jp/private/w51i6x1fvREKCcm2cK-q_1biy1mVVI9UT5pK0ARnwCvJwlehrHjTgHC3PdUd7vty/2021_March.kmz',
            'https://cdn.filesend.jp/private/EMED_2jX5MMq5ufwHDgdGxOli9IigjOUtnPbNmgK0e9OKSFrWLEuwZ1crzJLFr84/2021_Mar.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/Ovkgs_ni__Lm9oCQMb4OtPx7qrGQL5aKNvxE-DROsUoerz5f4m_X-GsIOOSMIF9b/2021_Apr.kmz',
            'https://cdn.filesend.jp/private/u2DgQngXkA_nWTs2QdjLJUH6_74aFngzdtsqU6LcvYMOTDOBJugiaVDflkss62kZ/2021_April.kmz',
            'https://cdn.filesend.jp/private/43xBvjV_Rt1eAGxG8G4T4JI_5wS_OY3cJzbsqT03K9COI_RP5p5_VEqabngZHTca/2021_Apr.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/KtvQXyCXsNi9ZZ2fdjuifvgAORRNbKv5iNI5UBgHhCyg-ItjQp7c07Fm3m6Ot4r3/2021_May.kmz',
            'https://cdn.filesend.jp/private/2BfTCiWpAMEN17414_UJ-vTeC_5D29g7_FOAFa5Z1CuvO1UDYKsFAVtBe7YZdfKD/2021_May.kmz',
            'https://cdn.filesend.jp/private/maihr52YV3FUb07E3JKNo4o8tM5add0eKiL3Zv-MGJQ-EwBroajgoasFu_QV-A1-/2021_May.kmz'
          ],
          [
            'https://cdn.filesend.jp/private/HocCqRJTWabAcmaz-ykwgejV7OBbxzJLV-L32vgn3s8WAgarzjK3YBBXyiJrkBZ1/2021_Jun.kmz',
            'https://cdn.filesend.jp/private/hv6LWbBP_tMczYo36uj7D-kPtw0fjAqgJlAVYPp0oSANsPi6cEz2t9M-YVjYihkf/2021_June.kmz',
            'https://cdn.filesend.jp/private/0Bd-16_I5die_ncZJ2GsxpqgzroxsnxLUeDiwYaksr_JFieVirOULeynirKwySs7/2021_Jun.kmz'
          ]
        ]
      }
    }
  ]
  const [yearCount, setYearCount] = useState(2016)
  const yearChoices = sourceMonth.map((item, index) => item['year'])

  const [sources, setSources] = useState(sourcesYear)
  const [marks, setMarks] = useState(
    sourcesYear.map((item, index) => {
      return {
        value: index,
        label: item.year
      }
    })
  )

  const handleSliderChange = (_, newValue) => {
    setCount(newValue)
  }

  const handeModeChange = (event, newValue) => {
    const newMode = event.target.value

    const newSources =
      newMode === 'Yearly'
        ? cloneDeep(sourcesYear)
        : cloneDeep(sourceMonth).filter(monthData => {
            if (monthData['year'] == yearCount) return monthData
          })[0]
    setSources(newSources)
    setMode(newMode)
    setCount(0)
    setMarks(
      newMode === 'Yearly'
        ? newSources.map((item, index) => {
            return {
              value: index,
              label: item.year
            }
          })
        : newSources['data'][factor].map((item, index) => {
            let month
            if (index === 1) {
              month = 'January'
            } else if (index === 2) {
              month = 'February'
            } else if (index === 3) {
              month = 'March'
            } else if (index === 4) {
              month = 'April'
            } else if (index === 5) {
              month = 'May'
            } else if (index === 6) {
              month = 'June'
            } else if (index === 7) {
              month = 'July'
            } else if (index === 8) {
              month = 'August'
            } else if (index === 9) {
              month = 'September'
            } else if (index === 10) {
              month = 'October'
            } else if (index === 11) {
              month = 'November'
            } else if (index === 12) {
              month = 'December'
            } else {
              month = 'Clear View'
            }
            return {
              value: index,
              label: month
            }
          })
    )
  }

  const handleYearChange = event => {
    const newYear = event.target.value
    setYearCount(newYear)
    const newSources =
      mode === 'Yearly'
        ? cloneDeep(sourcesYear)
        : cloneDeep(sourceMonth).filter(monthData => {
            if (monthData['year'] == newYear) return monthData
          })[0]
    setSources(newSources)
  }

  console.log(mode)
  return (
    <>
      <NavBar setViewPage={setViewPage} viewPage={viewPage} />
      <div style={{ alignItems: 'center' }}>
        {viewPage === 'AgwePage' ? (
          <AgwePage setViewPage={setViewPage} />
        ) : viewPage === 'MapPage' ? (
          <Grid container>
            <Grid
              item
              xs={12}
              textAlign='center'
              style={{ paddingBottom: '1vh' }}
            ></Grid>
            <Grid item textAlign='start' xs={8} style={{ paddingLeft: '1vh' }}>
              <Grid container>
                <Grid item xs={12}>
                  <Map
                    source={
                      count >= 0
                        ? mode === 'Yearly'
                          ? sources[count]['data'][factor]
                          : sources['data'][factor][count]
                        : null
                    }
                  />
                </Grid>
                {factor !== 'sst' ? (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        variant={'subtitle'}
                        style={{ fontSize: '1vh' }}
                      >
                        {`[1] Algae, phytoplankton and chlorophyll. Environmental Measurement Systems.
                   (2021, September 27). Retrieved October 2, 2021, 
                   from https://www.fondriest.com/environmental-measurements/parameters/water-quality/algae-phytoplankton-chlorophyll.`}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant={'subtitle'}
                        style={{ fontSize: '1vh' }}
                      >
                        {`[2] Nutrients, eutrophication and harmful algal blooms along the freshwater to marine continuum. (2020). WIREs Water, 7(4). https://doi.org/10.1002/wat2.1453 `}
                      </Typography>
                    </Grid>
                  </>
                ) : (
                  <>
                    {' '}
                    <Grid item xs={12}>
                      <Typography
                        variant={'subtitle'}
                        style={{ fontSize: '1vh' }}
                      >
                        {`[3] US Department of Commerce; NOAA; National Environmental Satellite Data and Information Service;
                     Office of Satellite and Product Operations. (2011, September 29). NOAA's office of satellite and product 
                     operations. Office of Satellite and Product Operations. Retrieved October 2, 2021, from https://www.ospo.noaa.gov.
                    `}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item textAlign='center' xs={4} style={{ paddingTop: '1vh' }}>
              <Grid container>
                <Grid item xs={12}>
                  {
                    <img
                      src={factor === 'sst' ? sALegend : CLegend}
                      alt=''
                      width='550vw'
                      height='300vh'
                    />
                  }
                </Grid>
                <Grid
                  item
                  xs={4}
                  textAlign='start'
                  style={{ paddingTop: '2vh' }}
                >
                  {mode === 'Monthly' ? (
                    <Grid
                      item
                      xs={12}
                      textAlign='start'
                      style={{ paddingTop: '0.5vh', paddingLeft: '9vh' }}
                    >
                      <>to : </>
                      <Select value={yearCount} onChange={handleYearChange}>
                        {sourceMonth.map((item, index) => {
                          return (
                            <MenuItem
                              key={`${index}-${item['year']}`}
                              value={item['year']}
                            >
                              {item['year']}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </Grid>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Grid
                  item
                  xs={8}
                  textAlign='start'
                  style={{ paddingTop: '2vh', paddingLeft: '3vw' }}
                >
                  {count >= 1 ? (
                    <div>{`You are viewing: ${marks[count]['label']} ${mode} Average Layout`}</div>
                  ) : (
                    <div>{`You are viewing: ${marks[count]['label']}`}</div>
                  )}
                  <Slider
                    defaultValue={0}
                    step={1}
                    max={
                      mode === 'Yearly'
                        ? sources.length - 1
                        : sources['data'][factor].length - 1
                    }
                    style={{ width: '10vw' }}
                    onChange={handleSliderChange}
                  />
                </Grid>
                <Grid
                  item
                  xs={5}
                  textAlign='start'
                  style={{ paddingTop: '1vh', paddingLeft: '0.5vh' }}
                >
                  <>Change Views: </>
                  <Select value={mode} onChange={handeModeChange}>
                    {modeChoices.map((item, index) => (
                      <MenuItem value={item} key={`${item}-${index}`}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={7}
                  textAlign='start'
                  style={{ paddingTop: '1vh', paddingLeft: '0vw' }}
                >
                  <>Observe </>
                  <Select
                    value={factor}
                    onChange={event => setFactor(event.target.value)}
                  >
                    {factorList.map((item, index) => (
                      <MenuItem value={item} key={`${item}-${index}`}>
                        {item === 'sst'
                          ? 'Sea Surface Temperature'
                          : 'Chlorophyll'}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={12}
                  textAlign='start'
                  style={{ paddingTop: '2vh', paddingLeft: '1vw' }}
                >
                  <Typography variant={'h5'}>
                    {factor !== 'sst' ? (
                      <>
                        <strong>{`Chlorophyll`}</strong>
                        {` is a color pigment found in algae, phytoplankton, and plants. 
                        This molecule makes algae and plants the color green. 
                        Chlorophyll is used as a photoreceptor in photosynthesis. 
                        These photoreceptors absorb light energy, while chlorophyll absorbs energy from sunlight. 
                        [1] high levels of chlorophyll would result in high levels of nutrients. 
                        Increase levels of these nutrients associated with the occurrence of algal bloom.[2] 
                        The increase in nutrients is caused by human activities such as the use of fertilizer for farming, 
                        improper sewage of animal farms and burning of fossil fuels.
`}
                      </>
                    ) : (
                      <>
                        <strong>{`Sea surface temperature, or ocean surface temperature,`}</strong>
                        {` is 
                    the water temperature close to the ocean's surface. 
                    It is also called the skin temperature of the ocean surface water. SST is 
                    measured in order to understand the communication between the atmosphere and 
                    ocean.  Increase levels of sea surface temperatures is projected to increase 
                    the risk for production of Harmful Algal blooms.[3]`}
                      </>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : viewPage === 'AboutUsPage' ? (
          <AboutUsPage />
        ) : viewPage === 'ResourcesPage' ? (
          <ResourcesPage />
        ) : viewPage === 'ContactUsPage' ? (
          <ContactUs />
        ) : (
          <AgwePage />
        )}
      </div>
    </>
  )
}

export default MainWhole
